import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { BrowseLevelsLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels._context";
import { useBrowseLevelsStudyGraphemesQuery } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels.navigator";
import { useMemo } from "react";
import { getLevelsPackProgress } from "#get-levels-pack-progress";

/** Nothing counts as studied before the study query settles; the counts show as pending. */
const NO_STUDY_DATA_YET: ReadonlySet<string> = new Set();

/** The selected pack's progress; `isPending` until the learner's studied characters load. */
export function useLevelsPackProgress() {
  const [levels, dataset, gradeParts, curriculumGrade] = useContextSelectors(
    BrowseLevelsLayoutContext,
    (c) => c.characterLevels,
    (c) => c.curriculumDataset,
    (c) => c.gradeParts,
    (c) => c.curriculumGrade,
  );
  const studied = useBrowseLevelsStudyGraphemesQuery().data;
  const progress = useMemo(
    () =>
      getLevelsPackProgress({
        dataset,
        gradeParts,
        levels,
        studied: studied ?? NO_STUDY_DATA_YET,
        tabValue: curriculumGrade,
      }),
    [curriculumGrade, dataset, gradeParts, levels, studied],
  );
  return { isPending: studied === undefined, progress };
}
